import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { NavRoute } from 'models/NavRoutes';
import { useTranslation } from 'react-i18next';

import './FmSubNavigation.styles.scss';
import './FmSubNavigation.styles.responsive.scss';

type FmSubNavigationProps = {
  className?: string;
  routes: NavRoute[];
};

const FmSubNavigation: React.FC<FmSubNavigationProps> = (props) => {
  const { className, routes } = props;
  const { t } = useTranslation();

  const classes = classNames('fm-sub-navigation', className);

  return (
    <nav className={classes}>
      <ul>
        {routes.map(({ path, label }) => (
          <li key={path}>
            <NavLink
              className={({ isActive }) => {
                return classNames('as-button', 'white-content-card-container', {
                  selected: isActive,
                });
              }}
              to={path}
            >
              {t(label)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FmSubNavigation;
